// extracted by mini-css-extract-plugin
export default {"root":"Reviews__root--mdJKk","review-holder":"Reviews__review-holder--Wzmqu","reviewHolder":"Reviews__review-holder--Wzmqu"};